import iata_cities from "../iata_cities.json";

const normalize = (s) => s.trim().toLowerCase();

/**
 * If multiple matches exist, prefer the one with the largest population.
 * @param {string} city
 * @param {string} country
 * @returns {object|null} The matched city object from iata_cities.json or null
 */
export function resolveCityFromIATA(city, country) {
  if (!city || !country) return null;

  const matches = iata_cities.filter(
    (entry) =>
      normalize(entry.city) === normalize(city) &&
      normalize(entry.country_name) === normalize(country)
  );

  if (matches.length === 0) {
    // fallback: try city-only match
    const cityMatches = iata_cities.filter(
      (entry) => normalize(entry.city) === normalize(city)
    );

    if (cityMatches.length === 0) return null;
    if (cityMatches.length === 1) return cityMatches[0];

    return cityMatches.reduce((a, b) => (a.population > b.population ? a : b));
  }

  if (matches.length === 1) return matches[0];

  return matches.reduce((a, b) => (a.population > b.population ? a : b));
}
